import { useTranslation } from 'react-i18next';
import { Clock, BadgeCheck, BadgeDollarSign, XCircle } from 'lucide-react';
import { ADMIN_COLORS } from '../utils/adminAnimations';
import { STATUS_BADGE } from '@/constants/theme';

export const STATUS_BADGE_CONFIG: Record<string, { icon: typeof Clock; bg: string; fg: string; shadow: string }> = {
  SUBMITTED: { icon: Clock, bg: ADMIN_COLORS.warningBg, fg: ADMIN_COLORS.warningText, shadow: ADMIN_COLORS.shadow },
  APPROVED: { icon: BadgeCheck, bg: ADMIN_COLORS.successBg, fg: ADMIN_COLORS.successText, shadow: ADMIN_COLORS.shadow },
  REJECTED: { icon: XCircle, bg: ADMIN_COLORS.dangerBg, fg: ADMIN_COLORS.dangerText, shadow: ADMIN_COLORS.shadow },
  PAID: { icon: BadgeDollarSign, bg: STATUS_BADGE.PAID.bg, fg: STATUS_BADGE.PAID.color, shadow: ADMIN_COLORS.shadow },
};

export const STATUS_LABEL_KEY: Record<string, string> = {
  SUBMITTED: 'admin.statusPending',
  APPROVED: 'admin.statusApproved',
  REJECTED: 'admin.statusRejected',
  PAID: 'admin.statusPaid',
};

export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation();
  const cfg = STATUS_BADGE_CONFIG[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap"
      style={{
        background: cfg.bg,
        color: cfg.fg,
        boxShadow: cfg.shadow,
      }}
    >
      <Icon className="w-3 h-3" />
      {t(STATUS_LABEL_KEY[status] ?? status)}
    </span>
  );
}
